const SSO_ERROR_MESSAGES: Record<string, string> = {
  EMAIL_NOT_VERIFIED: "Your email must be verified before login.",
  PASSWORD_RESET_REQUIRED: "You must reset your password before logging in.",
  PASSWORD_EXPIRED: "Your password has expired. Please reset your password to continue.",
  PASSWORD_POLICY_ERROR: "Unable to evaluate password policy."
};

export const DEFAULT_SSO_ERROR_MESSAGE = "Sign-in failed. Please try again.";

/**
 * Maps the `error` query param from the SSO redirect to user-facing copy.
 * Unknown codes get {@link DEFAULT_SSO_ERROR_MESSAGE}.
 */
export function getSSOErrorMessage(errorCode: string | null): string {
  if (!errorCode?.trim()) {
    return DEFAULT_SSO_ERROR_MESSAGE;
  }
  return SSO_ERROR_MESSAGES[errorCode] ?? errorCode;
}
